<ng-content></ng-content>
<app-loading [loading]="loading" [showText]="false"></app-loading>
<div *ngIf="loading === false" style="text-align: center;" class="m-y-4">
    <app-button (click)="doAction()" [disabled]="!formGroup.valid" [label]="buttonLabel"
                *ngIf="displayButton"
                size="small"
                [withMargin]="true"
                fill="solid"></app-button>
    <ng-content select="[buttons]">
    </ng-content>
</div>
